import axios from 'axios'
import qs from 'qs'
import router from '@/router/index.js'
import {
	Notification,
	Message
} from 'element-ui'
import store from '../store'



// 创建 axios 实例
var requests = axios.create({
	//   baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
	baseURL: 'http://api.kkzh.com/',
	// baseURL:'http://api.bbzsh.com/',
	// baseURL: 'http://127.0.0.1:30040/',
	// baseURL: 'https://api.h6ds.com',
	timeout: 6000, // 请求超时时间
	responseType: 'json',
	// withCredentials: true,
})

requests.interceptors.request.use(
	req => {


		var token = localStorage.getItem('usertoken')
		req.data.token = token

		
		req.data = qs.stringify(req.data);
		req.headers = {
			"Content-Type": "application/x-www-form-urlencoded"
		}

	

		return req
	},
	e => {



	}
)





// 错误处理函数
const err = (error) => {




	if (error.response) {
		const data = error.response.data
		// const token = Vue.ls.get(ACCESS_TOKEN)
		if (error.response.status === 403) {
			//         Notify({ type: 'danger', message: data.message||data.msg });
		}
		if (error.response.status === 401) {

			Message.error({
				message: '请先登录',
				duration: 3000,
				// offset: "580"
			})
			store.commit('SET_open_login', true)
			


			//         Notify({ type: 'danger', message: '你没有权限。' });
			// if (token) {
			//   store.dispatch('Logout').then(() => {
			//     setTimeout(() => {
			//       window.location.reload()
			//     }, 1500)
			//   })
			// }
		}
	}
	return Promise.reject(error)
}



// request interceptor(请求拦截器)
// requests.interceptors.request.use(config => {
// //   const token = Vue.ls.get(ACCESS_TOKEN)
//   const token = localStorage.getItem('token')
//   if (token) {
//     config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
//   }
//   return config
// }, err)



// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
	const res = response.data

	if (res.code !== 1 && res.code !== 200) {

		// 401:未登录;
		if (res.code === 401 || res.code === 403 || res.code === 999) {

		}



		return Promise.reject(res)
	} else {
		return res
	}
}, err)



export default {
	requests
}